import React, { Component } from 'react'
import PropTypes from 'prop-types'

class PersonalityResultsPieChart extends Component {
  static propTypes = {
    chartData: PropTypes.any.isRequired,
    image: PropTypes.any.isRequired,
    height: PropTypes.any,
  }
  static defaultProps = {
    height: 400,
  }

  constructor(props) {
    super(props)

    this.constructChart = (container, data) => {
      const { image, height } = this.props
      new window.PieChart({
        container,
        data: {
          preloaded: data,
        },
        area: {
          height: height,
          style: {
            image,
          },
        },
        interaction: {
          mode: "select",
          resizing: {
            enabled: false,
          }
        },
        pie: {
          innerRadius: 0.7,
          style: {
            sliceColors: [
              '#30BC9D', '#FF9552', '#5099DE', '#EE6352',
              '#68CEB7', '#FFA871', '#7FB4E7', '#F28D81',
              '#338472', '#D17A44', '#33628E', '#A04438',
            ],
            colorDistribution: 'list',
          },
        },
        slice: {
          style: {
            label: {
              textStyle: {font: "12px Open Sans"},
            }
          }
        },
      })
    }
  }

  componentDidMount() {
    const container = document.getElementById('personality-results-pie-chart')
    this.constructChart(container, this.props.chartData)
  }

  render() {
    return <div id="personality-results-pie-chart" />
  }
}

export default PersonalityResultsPieChart



// WEBPACK FOOTER //
// ./src/components/ui/charts/zoom/PersonalityResultsPieChart.js